import { Modal } from 'antd'
import { Download, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { formatFileName, downloadFileWithName } from '@/utils/download'

export interface PreviewFile {
  url: string
  name: string
  type?: number
}

interface MediaPreviewModalProps {
  file: PreviewFile | null
  onClose: () => void
  onDownload?: (url: string, fileName?: string) => void
}

export function MediaPreviewModal({
  file,
  onClose,
  onDownload,
}: MediaPreviewModalProps) {
  const handleDownload = () => {
    if (!file) return
    if (onDownload) {
      onDownload(file.url, file.name)
    } else {
      downloadFileWithName({ url: file.url, fileName: file.name })
    }
  }

  return (
    <Modal
      open={!!file}
      onCancel={onClose}
      footer={null}
      width={750}
      closeIcon={null}
      className="[&_.ant-modal-container]:!bg-white rounded-xl"
      title={
        <div className="flex items-center justify-between">
          <span
            className="max-w-[450px] font-semibold text-base whitespace-nowrap overflow-hidden"
            title={
              file?.name ? formatFileName(file.name, 'download') : undefined
            }
          >
            {file?.name ? formatFileName(file.name, 'display') : ''}
          </span>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              className="h-8 border-[#CE7A58] text-[#CE7A58] hover:bg-[#CE7A58]/10"
              onClick={handleDownload}
            >
              <Download size={14} />
              <span>Tải xuống</span>
            </Button>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X size={18} />
            </Button>
          </div>
        </div>
      }
      centered
      destroyOnHidden
    >
      <div className="mt-4 flex flex-col items-center justify-center bg-black/5 rounded-lg p-2 min-h-[200px]">
        {file?.type === 1 && (
          <video
            src={file.url}
            controls
            autoPlay
            className="w-full max-h-[65vh] rounded object-contain"
          >
            <track kind="captions" label="Phụ đề" />
          </video>
        )}
        {file?.type === 2 && (
          <img
            src={file.url}
            alt={file.name}
            className="w-full max-h-[65vh] rounded object-contain"
          />
        )}
        {file?.type === 3 && (
          <div className="w-full py-8 px-4 flex flex-col items-center">
            <audio src={file.url} controls autoPlay className="w-full">
              <track kind="captions" label="Phụ đề" />
            </audio>
          </div>
        )}
        {(!file?.type || file.type === 4) && (
          <iframe
            src={file?.url}
            className="w-full h-[65vh] border-0 rounded"
            title={file?.name}
          />
        )}
      </div>
    </Modal>
  )
}
